import { render, staticRenderFns } from "./FooterApp.vue?vue&type=template&id=176e40f2&scoped=true&lang=pug"
import script from "./FooterApp.vue?vue&type=script&lang=ts"
export * from "./FooterApp.vue?vue&type=script&lang=ts"
import style0 from "./FooterApp.vue?vue&type=style&index=0&id=176e40f2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176e40f2",
  null
  
)

export default component.exports